import type { PricingTableSection, Field } from '@getaccept/editor-lib';
import { PricingTableHelper } from '../pricing-table.helper';

export const getSection = (sections: PricingTableSection[], sectionId: string) =>
  sections.find(section => section.id === sectionId);

export const getSectionHeader = (sections: PricingTableSection[], sectionId: string) =>
  getSection(sections, sectionId)?.displayName;

export const getColumns = (sections: PricingTableSection[], sectionId: string) =>
  getSection(sections, sectionId)?.columns;

export const getRows = (sections: PricingTableSection[], sectionId: string) =>
  getSection(sections, sectionId)?.rows;

export const getGridTemplateColumns = (sections: PricingTableSection[], sectionId: string) => {
  const columnWidths = PricingTableHelper.getEnabledColumns(getColumns(sections, sectionId))
    ?.filter(column => column.enabled)
    .map(column => column.width);
  const widthString = columnWidths?.join('% ');
  return `grid-template-columns: ${widthString}%;`;
};

export const getRowsSortedByColumnOrder = (sections: PricingTableSection[], sectionId: string) =>
  getRows(sections, sectionId)?.map(row => ({
    ...row,
    values: getColumns(sections, sectionId).flatMap(column =>
      row.values.find(rowValue => rowValue.columnId === column.id)
    ),
  }));

export const getSectionSummary = (
  sections: PricingTableSection[],
  sectionId: string,
  isPreCalculated: boolean,
  fields: Field[]
) => {
  const section = getSection(sections, sectionId);
  if (isPreCalculated) {
    return section.sectionSummary;
  }
  const columns = getColumns(sections, sectionId);
  const rows = getRows(sections, sectionId);
  const rowsFromInputFieldValues = PricingTableHelper.getRowsFromInputFieldValues(
    PricingTableHelper.getEnabledRows(rows, fields),
    PricingTableHelper.getEnabledColumns(columns),
    fields
  );

  return PricingTableHelper.calculateSectionSummary(
    rowsFromInputFieldValues,
    columns,
    section.sectionSummary
  );
};
